import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllDataQuotationSlice = createSlice({
    name: "getAllDataQuotation",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllDataQuotationSlice_actions = getAllDataQuotationSlice.actions;
export var fetchData = _getAllDataQuotationSlice_actions.fetchData, fetchDataSuccess = _getAllDataQuotationSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllDataQuotationSlice_actions.fetchDataFailure, resetState = _getAllDataQuotationSlice_actions.resetState;
export default getAllDataQuotationSlice.reducer;
